/**
 * Created by lv on 2017/11/15.
 */
require('kindeditor/src/core.js')
require('kindeditor/src/node.js')
require('kindeditor/src/config.js')
require('kindeditor/src/event.js')
require('kindeditor/src/html.js')
require('kindeditor/src/selector.js')
require('kindeditor/src/range.js')
require('kindeditor/src/cmd.js')
require('kindeditor/src/widget.js')
require('kindeditor/src/edit.js')
require('kindeditor/src/toolbar.js')
require('kindeditor/src/menu.js')
require('kindeditor/src/colorpicker.js')
require('kindeditor/src/uploadbutton.js')
require('kindeditor/src/dialog.js')
require('kindeditor/src/tabs.js')
require('kindeditor/src/ajax.js')
require('kindeditor/src/main.js')
require('kindeditor/lang/zh-CN.js')

require('kindeditor/plugins/anchor/anchor.js')
require('kindeditor/plugins/autoheight/autoheight.js')
require('kindeditor/plugins/baidumap/baidumap.js')
require('kindeditor/plugins/map/map.js')
require('kindeditor/plugins/clearhtml/clearhtml.js')
require('kindeditor/plugins/code/code.js')
require('kindeditor/plugins/emoticons/emoticons.js')
require('kindeditor/plugins/filemanager/filemanager.js')
require('kindeditor/plugins/flash/flash.js')
// require('kindeditor/plugins/image/image.js')
require('kindeditor/plugins/insertfile/insertfile.js')
require('kindeditor/plugins/lineheight/lineheight.js')
require('kindeditor/plugins/link/link.js')
require('kindeditor/plugins/map/map.js')
require('kindeditor/plugins/media/media.js')
// require('kindeditor/plugins/multiimage/multiimage.js')
require('kindeditor/plugins/pagebreak/pagebreak.js')
require('kindeditor/plugins/plainpaste/plainpaste.js')
require('kindeditor/plugins/preview/preview.js')
require('kindeditor/plugins/quickformat/quickformat.js')
require('kindeditor/plugins/table/table.js')
require('kindeditor/plugins/template/template.js')
require('kindeditor/plugins/wordpaste/wordpaste.js')



